var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid",class:_vm.classNames,style:(_vm.computedStyles),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }